import React from "react";
import Button from "../Button";

interface PageContainerProps {
    title: string;
    children: React.ReactNode;
    label?: string;
    overviewTime?: string | null;
    onClick?: () => void;
}

export default function ContentBlock({ title, children, label, overviewTime, onClick }: PageContainerProps) { 
    return (
        <div className="content-block">
            <div className="block-title title-properties rounded flex justify-between items-center rounded dark:bg-nred">
                <h3 className="dark:text-black">{title}</h3>
                <div>{overviewTime}</div>
                {/* {label && onClick && <Button label={label} width='full' onClick={onClick} />} */}
            </div>
            <div className="sub-content flex flex-col gap-1">
                {children}
            </div>
        </div>
    );
}
